var map = {
	"./API/Index.vue": 2009,
	"./API/Partials/ApiTokenManager.vue": 8096,
	"./AdaptiveBlocks/Edit.vue": 9131,
	"./AdaptiveBlocks/Index.vue": 9091,
	"./Auth/ConfirmPassword.vue": 5424,
	"./Auth/ForgotPassword.vue": 5763,
	"./Auth/Login.vue": 2107,
	"./Auth/Register.vue": 4211,
	"./Auth/ResetPassword.vue": 9590,
	"./Auth/TwoFactorChallenge.vue": 8239,
	"./Auth/VerifyEmail.vue": 991,
	"./Awards/Create.vue": 2431,
	"./Awards/Edit.vue": 4447,
	"./Awards/Index.vue": 4881,
	"./BrandMonitoring/Dashboard/Index.vue": 9044,
	"./BrandMonitoring/Mentions/Edit.vue": 5632,
	"./BrandMonitoring/Mentions/Index.vue": 8917,
	"./BrandMonitoring/Platforms/Edit.vue": 8783,
	"./BrandMonitoring/Platforms/Index.vue": 7863,
	"./BrandMonitoring/SearchQueries/Create.vue": 9223,
	"./BrandMonitoring/SearchQueries/Edit.vue": 8734,
	"./BrandMonitoring/SearchQueries/Index.vue": 6771,
	"./BundleItems/Edit.vue": 3113,
	"./Bundles/Create.vue": 2109,
	"./Bundles/Edit.vue": 224,
	"./Bundles/Index.vue": 8778,
	"./Dashboard.vue": 3106,
	"./Error.vue": 2494,
	"./Events/Create.vue": 6965,
	"./Events/Edit.vue": 61,
	"./Events/Index.vue": 7634,
	"./MainPage/Index.vue": 7161,
	"./MediaViewer/Index.vue": 5980,
	"./NL/Create.vue": 5715,
	"./NL/Edit.vue": 4283,
	"./NL/Index.vue": 2973,
	"./News/Create.vue": 9133,
	"./News/Edit.vue": 1947,
	"./News/Index.vue": 2363,
	"./Pages/Create.vue": 1435,
	"./Pages/Edit.vue": 7603,
	"./Pages/Index.vue": 9667,
	"./PressKit/Create.vue": 1219,
	"./PressKit/Edit.vue": 9730,
	"./PressKit/Index.vue": 898,
	"./PrivacyPolicy.vue": 6559,
	"./Profile/Partials/DeleteUserForm.vue": 7325,
	"./Profile/Partials/LogoutOtherBrowserSessionsForm.vue": 9882,
	"./Profile/Partials/TwoFactorAuthenticationForm.vue": 6704,
	"./Profile/Partials/UpdatePasswordForm.vue": 8720,
	"./Profile/Partials/UpdateProfileInformationForm.vue": 199,
	"./Profile/Show.vue": 1787,
	"./Publications/Create.vue": 5428,
	"./Publications/Edit.vue": 5337,
	"./Publications/Index.vue": 9836,
	"./Settings/Index.vue": 602,
	"./Tags/Create.vue": 9316,
	"./Tags/Edit.vue": 2683,
	"./Tags/Index.vue": 34,
	"./TeamMembers/Create.vue": 5216,
	"./TeamMembers/Edit.vue": 4800,
	"./TeamMembers/Index.vue": 63,
	"./TermsOfService.vue": 5846,
	"./Users/Create.vue": 6386,
	"./Users/Edit.vue": 8450,
	"./Users/Index.vue": 9323,
	"./Vacancy/Create.vue": 4011,
	"./Vacancy/Edit.vue": 6802,
	"./Vacancy/Index.vue": 7878,
	"./Welcome.vue": 8262,
	"./WorkItemPresets/Create.vue": 2204,
	"./WorkItemPresets/Edit.vue": 9208,
	"./WorkItemPresets/Index.vue": 7021,
	"./WorkItems/Create.vue": 7988,
	"./WorkItems/Edit.vue": 6713,
	"./WorkItems/Index.vue": 4144,
	"./Works/Create.vue": 6116,
	"./Works/Edit.vue": 9789,
	"./Works/Index.vue": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;